import React, { useEffect, useState } from 'react';
// import axios from 'axios';

const token = localStorage.getItem('adminToken');
// axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

export default function CoursesAdmin() {
  const [courses, setCourses] = useState([]);
  const [form, setForm] = useState({ title: '', subtitle: '', description: '', image: '', features: '', duration: '', price: '' });
  const [editId, setEditId] = useState(null);

  useEffect(() => fetchCourses(), []);

  const fetchCourses = async () => {
    //const res = await axios.get('http://localhost:5000/api/courses');
    setCourses("res.data");
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const payload = { ...form, features: form.features.split(',') };
    if (editId) {
    //   await axios.put(`http://localhost:5000/api/courses/${editId}`, payload);
    } else {
    //   await axios.post('http://localhost:5000/api/courses', payload);
    }
    reset();
    fetchCourses();
  };

  const reset = () => {
    setForm({ title: '', subtitle: '', description: '', image: '', features: '', duration: '', price: '' });
    setEditId(null);
  };

  const handleEdit = course => {
    setForm({ ...course, features: course.features.join(',') });
    setEditId(course._id);
  };

  const handleDelete = async id => {
    if (!window.confirm('Delete?')) return;
    //await axios.delete(`http://localhost:5000/api/courses/${id}`);
    fetchCourses();
  };

  return (
    <div>
      <h3 className="text-2xl font-bold mb-6">Manage Courses</h3>

      {/* Form */}
      <form onSubmit={handleSubmit} className="bg-white p-6 rounded-xl shadow mb-8 grid grid-cols-1 md:grid-cols-2 gap-4">
        <input className="border px-3 py-2 rounded" placeholder="Title" value={form.title} onChange={e => setForm({...form, title: e.target.value})} required />
        <input className="border px-3 py-2 rounded" placeholder="Subtitle" value={form.subtitle} onChange={e => setForm({...form, subtitle: e.target.value})} />
        <textarea className="border px-3 py-2 rounded md:col-span-2" placeholder="Description" value={form.description} onChange={e => setForm({...form, description: e.target.value})} />
        <input className="border px-3 py-2 rounded" placeholder="Image URL" value={form.image} onChange={e => setForm({...form, image: e.target.value})} />
        <input className="border px-3 py-2 rounded" placeholder="Features (comma sep)" value={form.features} onChange={e => setForm({...form, features: e.target.value})} />
        <input className="border px-3 py-2 rounded" placeholder="Duration" value={form.duration} onChange={e => setForm({...form, duration: e.target.value})} />
        <input className="border px-3 py-2 rounded" placeholder="Price" value={form.price} onChange={e => setForm({...form, price: e.target.value})} />
        <div className="md:col-span-2 flex gap-3">
          <button className="bg-blue-600 text-white px-4 py-2 rounded">Save</button>
          <button type="button" onClick={reset} className="bg-gray-300 px-4 py-2 rounded">Cancel</button>
        </div>
      </form>

      {/* List */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {courses.map(c => (
          <div key={c._id} className="bg-white p-4 rounded-xl shadow">
            <img src={c.image} alt={c.title} className="h-40 w-full object-cover rounded mb-3" />
            <h4 className="font-bold text-lg">{c.title}</h4>
            <p className="text-sm text-gray-600 mb-2">{c.subtitle}</p>
            <p className="text-sm mb-3">{c.description}</p>
            <div className="flex gap-2">
              <button onClick={() => handleEdit(c)} className="bg-yellow-400 text-black px-3 py-1 rounded text-sm">Edit</button>
              <button onClick={() => handleDelete(c._id)} className="bg-red-600 text-white px-3 py-1 rounded text-sm">Delete</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}